export const apiKey = process.env.REACT_APP_AIRBAGSHOP_API_KEY || "";
export const apiHost = process.env.REACT_APP_API_SERVER || "";
export const showManualQrCodeInput = window.location.port.startsWith("3") ;
